"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _IndexModule = _interopRequireDefault(require("../../Index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NewPassword = function NewPassword(_ref) {
  var onFinish = _ref.onFinish,
      onFinishFailed = _ref.onFinishFailed,
      userName = _ref.userName,
      loading = _ref.loading,
      setConfirmNewPassword = _ref.setConfirmNewPassword,
      setUserName = _ref.setUserName,
      setNewPassword = _ref.setNewPassword;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", {
    style: {
      width: "80%",
      color: "rgba(89,116,175,1)",
      fontWeight: "bold",
      marginBottom: "20px"
    }
  }, "Ingresa tu nueva contrase\xF1a"), /*#__PURE__*/_react["default"].createElement(_antd.Form, {
    name: "newPassword",
    className: _IndexModule["default"].loginForm,
    onFinish: onFinish,
    onFinishFailed: onFinishFailed
  }, /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    name: "username"
  }, /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    defaultValue: userName,
    className: "customeInput",
    disabled: true,
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.UserOutlined, {
      className: "site-form-item-icon"
    }),
    onChange: function onChange(e) {
      return setUserName(e.target.value);
    },
    placeholder: "Usuario"
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    name: "newPassword",
    rules: [{
      required: true,
      message: "Porfavor ingrese su contraseña"
    }]
  }, /*#__PURE__*/_react["default"].createElement(_antd.Input.Password, {
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.LockOutlined, {
      className: "site-form-item-icon"
    }),
    className: _IndexModule["default"].customeInput,
    onChange: function onChange(e) {
      return setNewPassword(e.target.value);
    },
    placeholder: "Nueva Contrase\xF1a"
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    name: "confirmNewPassword",
    dependencies: ["newPassword"],
    rules: [{
      required: true,
      message: "Por favor confirma tu contraseña"
    }, function (_ref2) {
      var getFieldValue = _ref2.getFieldValue;
      return {
        validator: function validator(rule, value) {
          if (!value || getFieldValue("newPassword") === value) return Promise.resolve();
          return Promise.reject("Las contraseñas no coinciden");
        }
      };
    }]
  }, /*#__PURE__*/_react["default"].createElement(_antd.Input.Password, {
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.LockOutlined, {
      className: "site-form-item-icon"
    }),
    className: _IndexModule["default"].customeInput,
    onChange: function onChange(e) {
      return setConfirmNewPassword(e.target.value);
    },
    placeholder: "Confirme Nueva Contrase\xF1a"
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_antd.Button, {
    type: "ghost",
    htmlType: "submit",
    block: true,
    className: _IndexModule["default"].loginButton,
    loading: loading
  }, "Ingresar"))));
};

var _default = NewPassword;
exports["default"] = _default;